export const BRAND = {
	LEXUS: 'lexus',
	TOYOTA: 'toyota',
}

export const GTM_ID = {
	lexus: {
		PROD: 'GTM-TBMZX75',
		ACC: 'GTM-M3DJ66N'
	},
	toyota: {
		PROD: 'GTM-M888SFJ',
		ACC: 'GTM-KCZWG74'
	}
}